/**
 * /me/payments/bank — Session 3d PR 11.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyBankInfoPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-bank-info", employeeId],
    queryFn: () => session3dApi.getBankInfo(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.bank-info.title", "Bank Details")}
        subtitle={t("me.bank-info.subtitle", "Where your salary lands. Changes routed through Khidmat per Article 90 + Mudad sync compliance.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.bank-info.title", "Bank Details"),
          window_label: t("me.bank-info.window", "current bank on file"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.bank-info.ask_khidmat", "I need to update my bank account.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.bank-info.detail_note",
                "Read-only bank account display. Updates require HR verification (Article 90 + Mudad sync). Use the Ask Khidmat button above to start a change request.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
